// #77 — announcements and release notes, shared by the webapp screens and the
// console. The rules on who reads what live in the Hasura metadata
// (public_release*.yaml); these are only the shapes and the version maths.

export type AnnouncementType = 'upcoming' | 'maintenance'

// Where a ticket sits in the console's sorting board, the same four columns
// as the compte rendu sharing (#115). Members only ever read `keep` and `edit`.
export type ReleaseColumn = 'todo' | 'keep' | 'edit' | 'drop'

// A delivered version as the git tag writes it: `v3.0.0`. Anything else (a
// `git describe` like `v2.1.0-89-gc9a6a2b8`, a hash) is not a release.
const versionPattern = /^v(\d+)\.(\d+)\.(\d+)$/

export function parseVersion(
  version: string
): { major: number; minor: number; patch: number } | null {
  const match = versionPattern.exec(version)
  if (!match) return null
  return { major: +match[1], minor: +match[2], patch: +match[3] }
}

// Only a major release (x.0.0) gets the « update done » banner (grilling of
// 27/09/2026).
export function isMajor(version: string): boolean {
  const parsed = parseVersion(version)
  return !!parsed && parsed.minor === 0 && parsed.patch === 0
}

export const releaseColumns: ReleaseColumn[] = ['todo', 'keep', 'edit', 'drop']

// One version as the backend ships it (packages/backend/src/features/release/
// tickets/<version>.json, written by scripts/nouveautes-tickets.sh). The
// console imports it into `release` / `release_item`, then Yohan sorts there.
export interface BundledRelease {
  version: string
  title: string
  // Set only for the versions delivered before #77, imported already published
  publishedAt: string | null
  items: BundledReleaseItem[]
}

export interface BundledReleaseItem {
  // Null for a line of a release note that has no ticket
  ticket: number | null
  ticketTitle: string | null
  proposedText: string
  sortColumn: ReleaseColumn
}
